export enum TransitType {
  Bus = 'Bus',
  Car = 'Car',
  Ferry = 'Ferry',
  Flight = 'Flight',
  Train = 'Train',
}
